import { render, staticRenderFns } from "./course_header.vue?vue&type=template&id=f0ac4660"
import script from "./course_header.vue?vue&type=script&lang=js"
export * from "./course_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports